// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { DnsRrTypeSchema } from '../inputTypeSchemas/DnsRrTypeSchema'

/////////////////////////////////////////
// DNS RECORD SCHEMA
/////////////////////////////////////////

export const DnsRecordSchema = z.object({
  rrType: DnsRrTypeSchema,
  ttl: z.number().int().nullable(),
  rdata: z.string(),
})

export type DnsRecord = z.infer<typeof DnsRecordSchema>

export default DnsRecordSchema;
